import type { DiscountGroupStatus } from '@erp/shared-types';
import { cn } from '@/lib/utils';

/**
 * Group status chip in the sales-order-v3 line-chip style: small radius
 * ("squarish") with a 10%-opacity tinted background rather than the saturated
 * Badge fills.
 */
const STATUS: Record<DiscountGroupStatus, { label: string; chip: string }> = {
  DRAFT: { label: 'Draft', chip: 'bg-foreground/8 text-muted-foreground' },
  PENDING_APPROVAL: {
    label: 'Pending Approval',
    chip: 'bg-orange-600/10 text-orange-700',
  },
  APPROVED: { label: 'Approved', chip: 'bg-green-600/10 text-green-700' },
  REJECTED: { label: 'Rejected', chip: 'bg-red-600/10 text-red-700' },
};

export function GroupStatusChip({ status }: { status: DiscountGroupStatus }) {
  const cfg = STATUS[status];
  return (
    <span
      className={cn(
        'inline-flex items-center justify-center gap-1 rounded px-2 py-1 text-xs font-medium whitespace-nowrap',
        cfg.chip,
      )}
    >
      {cfg.label}
    </span>
  );
}
